'use client';

import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import HostStorySection from './HostStorySection';
import VideoIntroduction from './VideoIntroduction';
/*import CommunityInvolvement from './CommunityInvolvement';*/
import CredentialsSection from './CredentialsSection';
import PersonalRecommendations from './PersonalRecommendations';
import GuestTestimonials from './GuestTestimonials';
import ContactSection from './ContactSection';

interface StoryMilestone {
  year: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
}

interface CommunityActivity {
  id: number;
  title: string;
  organization: string;
  description: string;
  image: string;
  imageAlt: string;
  icon: string;
}

interface Credential {
  id: number;
  title: string;
  issuer: string;
  year: string;
  icon: string;
}

interface Recommendation {
  id: number;
  category: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  icon: string;
  tip: string;
}

interface Testimonial {
  id: number;
  guestName: string;
  guestLocation: string;
  guestImage: string;
  guestImageAlt: string;
  rating: number;
  date: string;
  comment: string;
  highlight: string;
}

interface HostConnectionInteractiveProps {
  hostData: {
    name: string;
    title: string;
    heroImage: string;
    heroImageAlt: string;
    tagline: string;
    email: string;
    phone: string;
    responseTime: string;
  };
  storyData: {
    title: string;
    intro: string;
    milestones: StoryMilestone[];
  };
  videoData: {
    title: string;
    description: string;
    thumbnailImage: string;
    thumbnailAlt: string;
    videoUrl: string;
  };
  communityActivities: CommunityActivity[];
  credentials: Credential[];
  recommendations: Recommendation[];
  testimonials: Testimonial[];
}

export default function HostConnectionInteractive({
  hostData,
  storyData,
  videoData,
  communityActivities,
  credentials,
  recommendations,
  testimonials,
}: HostConnectionInteractiveProps) {
  return (
    <>
      <Header data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:102:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="102" data-component-end-line="102" data-component-file="HostConnectionInteractive.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />
      <HeroSection data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:103:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="103" data-component-end-line="109" data-component-file="HostConnectionInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D"
        hostName={hostData.name}
        hostTitle={hostData.title}
        heroImage={hostData.heroImage}
        heroImageAlt={hostData.heroImageAlt}
        tagline={hostData.tagline}
      />

      <HostStorySection data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:111:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="111" data-component-end-line="115" data-component-file="HostConnectionInteractive.tsx" data-component-name="HostStorySection" data-component-content="%7B%22elementName%22%3A%22HostStorySection%22%7D"
        storyTitle={storyData.title}
        storyIntro={storyData.intro}
        milestones={storyData.milestones}
      />

      <VideoIntroduction data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:117:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="117" data-component-end-line="123" data-component-file="HostConnectionInteractive.tsx" data-component-name="VideoIntroduction" data-component-content="%7B%22elementName%22%3A%22VideoIntroduction%22%7D"
        videoTitle={videoData.title}
        videoDescription={videoData.description}
        thumbnailImage={videoData.thumbnailImage}
        thumbnailAlt={videoData.thumbnailAlt}
        videoUrl={videoData.videoUrl}
      />

      {/* <CommunityInvolvement activities={communityActivities} /> */}

      <CredentialsSection data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:127:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="127" data-component-end-line="127" data-component-file="HostConnectionInteractive.tsx" data-component-name="CredentialsSection" data-component-content="%7B%22elementName%22%3A%22CredentialsSection%22%7D" credentials={credentials} />

      <PersonalRecommendations data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:129:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="129" data-component-end-line="129" data-component-file="HostConnectionInteractive.tsx" data-component-name="PersonalRecommendations" data-component-content="%7B%22elementName%22%3A%22PersonalRecommendations%22%7D" recommendations={recommendations} />

      <GuestTestimonials data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:131:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="131" data-component-end-line="131" data-component-file="HostConnectionInteractive.tsx" data-component-name="GuestTestimonials" data-component-content="%7B%22elementName%22%3A%22GuestTestimonials%22%7D" testimonials={testimonials} />

      <ContactSection data-component-id="src/app/host-connection/components/HostConnectionInteractive.tsx:133:6" data-component-path="src/app/host-connection/components/HostConnectionInteractive.tsx" data-component-line="133" data-component-end-line="137" data-component-file="HostConnectionInteractive.tsx" data-component-name="ContactSection" data-component-content="%7B%22elementName%22%3A%22ContactSection%22%7D"
        hostEmail={hostData.email}
        hostPhone={hostData.phone}
        responseTime={hostData.responseTime}
      />
    </>
  );
}